import React from 'react'
import PluginsDetail from "../../../components/PluginsDetail/PluginsDetail";
import {StyledContainer, StyledInnerContainer} from "./PluginsMainStyle";
// import SlackIntegration from '../../../resources/images/transformedToSvg/slack-integration.svg'
// import DiscordIntegration from '../../../resources/images/transformedToSvg/discord-integration.svg'
// import DiscordIntegration from '../../../resources/images/transformedToSvg/discord-integration.svg'
import slackIntegration from '../../../resources/images/slack-integration-3.svg'
import discordIntegration from '../../../resources/images/discord-integration-3.svg'

const PluginMain = () => {
    return (
        <StyledContainer>
            <StyledInnerContainer>
                <PluginsDetail title={'slackPlugin'} description={"slackPluginDescription"} img={slackIntegration}/>
                <PluginsDetail title={'discordPlugin'} description={"discordPluginDescription"}
                               img={discordIntegration}/>
            </StyledInnerContainer>
        </StyledContainer>
    )
}

export default PluginMain